import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { ActorCredentialConfigController } from '../../models/master/mastermodel';


@Pipe({
  name: 'ActorCredentialConfigFilter'
})

@Injectable()
export class ActorCredentialConfigPipe implements PipeTransform {

  transform(value: ActorCredentialConfigController[], filter: string): ActorCredentialConfigController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: ActorCredentialConfigController) =>
      app.CredentialTypeName != null && app.CredentialTypeName.toLocaleLowerCase().indexOf(filter) != -1
      || app.CredentialTypeGroup != null && app.CredentialTypeGroup.toString().indexOf(filter) != -1
      || app.CredentialTypeGroup != null && app.CredentialTypeGroup.toLocaleLowerCase().indexOf(filter) != -1
      || app.VerModeLongValue != null && app.VerModeLongValue.toString().indexOf(filter) != -1

    ) : value;
  }

}
